<template>
  <div>
    <OrderTemplate :step="2" :steps="steps">
      <template v-slot:stepCard>
        <TicketTable :tickets="reserveTickets" :thead="thead">
          <template slot="title">{{
            $t(
              `order_step_2_ticket_table_title${
                campaign.isLottery ? "_lottery" : ""
              }`
            )
          }}</template>
        </TicketTable>
      </template>

      <template v-slot:Contents>
        <v-card class="py-5 mt-5 rwd-padding" v-if="!campaign.isLottery">
          <div>
            <div
              class="
                text-center
                bg-tranparent-yellow
                pa-3
                text-title
                font-weight-bold
              "
            >
              {{ $t("order_step_2_discount_title") }}
            </div>
            <v-divider class="my-0 mt-2" />
            <v-row class="py-3 font-weight-bold text-nine" no-gutters>
              <v-col
                cols="6"
                sm="10"
                class="text-left"
                :class="$vuetify.breakpoint.xs ? 'pl-4' : 'px-8'"
                >{{ $t("order_step_2_discount_type") }}</v-col
              >
              <v-col
                cols="6"
                sm="2"
                class="text-right"
                :class="
                  $vuetify.breakpoint.xs ? 'text-right pr-4' : 'text-center'
                "
                >{{ $t("order_step_2_discount_price") }}</v-col
              >
            </v-row>
            <v-divider class="my-0" />
            <v-radio-group
              v-model="selectedDiscount"
              class="discountGroup px-3"
              @change="changeDiscount"
            >
              <v-row>
                <v-col
                  cols="9"
                  sm="10"
                  class="text-left"
                  :class="$vuetify.breakpoint.xs ? '' : 'px-8'"
                >
                  <v-radio value="0" color="primary">
                    <template slot="label">
                      <span class="font-weight-bold">
                        {{ $t("order_step_2_no_discount") }}
                      </span>
                    </template>
                  </v-radio>
                </v-col>
                <v-col
                  cols="3"
                  sm="2"
                  class="text-right"
                  :class="[
                    $vuetify.breakpoint.xs ? 'text-right' : 'text-center',
                    { 'primary-1--text': selectedDiscount == 0 }
                  ]"
                  >-NT.0</v-col
                >
              </v-row>
              <v-row>
                <v-col
                  cols="9"
                  sm="10"
                  class="text-left"
                  :class="$vuetify.breakpoint.xs ? '' : 'px-8'"
                >
                  <v-radio value="1" color="primary">
                    <template slot="label">
                      <div>
                        <div class="d-flex align-center font-weight-bold">
                          {{ $t("order_step_2_coupon_code_field") }}
                          <div v-if="!$vuetify.breakpoint.xs" class="d-flex">
                            <v-sheet max-width="250">
                              <v-text-field
                                v-model="couponCode"
                                :label="$t('order_step_2_coupon_code_required')"
                                outlined
                                color="primary-1"
                                class="ml-7 mr-5 couponField"
                                dense
                                :rules="[couponRequired]"
                                style="margin-bottom: -28px"
                                :error-messages="coupon.error"
                                @input="inputField"
                              ></v-text-field>
                            </v-sheet>

                            <v-btn
                              depressed
                              class="nextBtn"
                              @click="checkCoupon"
                              :class="{ disabledBtn: selectedDiscount !== '1' }"
                              :disabled="selectedDiscount !== '1'"
                            >
                              {{ $t("order_step_2_discount_cta") }}
                            </v-btn>
                          </div>
                        </div>
                        <div class="text-caption" v-if="coupon.name">
                          {{ coupon.name }}
                        </div>
                      </div>
                    </template>
                  </v-radio>
                </v-col>
                <v-col
                  cols="3"
                  sm="2"
                  class="text-right"
                  :class="[
                    $vuetify.breakpoint.xs ? 'text-right' : 'text-center',
                    { 'primary-1--text': selectedDiscount == '1' }
                  ]"
                  >-NT.{{ coupon.discount || 0 }}</v-col
                >
              </v-row>
              <v-row>
                <div v-if="$vuetify.breakpoint.xs" class="d-flex ml-9 mb-5">
                  <v-sheet max-width="200">
                    <v-text-field
                      v-model="couponCode"
                      :label="$t('order_step_2_coupon_code_required')"
                      outlined
                      color="primary-1"
                      class="ml-7 mr-5 couponField"
                      dense
                      :rules="[couponRequired]"
                      style="margin-bottom: -28px"
                      :error-messages="coupon.error"
                      @input="inputField"
                    ></v-text-field>
                  </v-sheet>

                  <v-btn
                    depressed
                    class="nextBtn"
                    @click="checkCoupon"
                    :class="{ disabledBtn: selectedDiscount !== '1' }"
                    :disabled="selectedDiscount !== '1'"
                  >
                    {{ $t("order_step_2_discount_cta") }}
                  </v-btn>
                </div>
              </v-row>
              <v-row
                v-if="ccDiscounts && ccDiscounts.length"
                v-for="(discount, dIndex) in ccDiscounts"
                :key="`discount-${dIndex}`"
              >
                <v-col
                  cols="9"
                  sm="10"
                  class="text-left"
                  :class="$vuetify.breakpoint.xs ? '' : 'px-8'"
                >
                  <v-radio :value="String(dIndex + 2)" color="primary">
                    <template slot="label">
                      <div class="font-weight-bold">
                        <div>
                          {{ discount.discountTitle }}
                        </div>
                        <div class="text-caption">
                          {{ $t("order_step_2_discount_limit") }}
                          <template
                            v-for="(t, ticketIndex) in discount.ticketNames"
                            ><span
                              :key="`discount-and-${ticketIndex}`"
                              v-if="ticketIndex !== 0"
                              >{{ $t("order_step_2_discount_and") }}</span
                            >{{ t }}</template
                          >
                        </div>
                      </div>
                    </template>
                  </v-radio>
                </v-col>
                <v-col
                  cols="3"
                  sm="2"
                  class="text-right"
                  :class="[
                    $vuetify.breakpoint.xs ? 'text-right' : 'text-center',
                    { 'primary-1--text': selectedDiscount == dIndex + 2 }
                  ]"
                  >-NT.{{ discount.discount_total }}</v-col
                >
              </v-row>
            </v-radio-group>
          </div>
        </v-card>
        <v-card
          id="applicant"
          class="py-5 mt-5 rwd-padding"
          v-if="sessionInfo.realNameRegistration"
        >
          <div>
            <div
              class="
                text-center
                bg-tranparent-yellow
                pa-3
                text-title
                font-weight-bold
              "
            >
              {{ $t("order_step_2_applicant") }}
            </div>
            <div class="text-center pt-5">
              <v-row
                v-for="(appli, i) in applicants"
                :class="
                  `applicant-info mx-7 ${
                    isSubmit && !appli.isComplete ? 'pink-1' : ''
                  }`
                "
                :key="`applicant-${i}`"
              >
                <v-col
                  class="text-left d-flex px-0 px-md-4 align-center"
                  cols="1"
                  sm="1"
                  md="1"
                >
                  <span
                    class="applicant-number"
                    :class="{ 'grey lighten-1': !appli.isComplete }"
                  >
                    <template v-if="!appli.isComplete">{{ i + 1 }}</template>
                    <v-icon v-else small color="white">mdi-check</v-icon>
                  </span>
                </v-col>
                <v-col class="text-left" cols="9" sm="9" md="9">
                  <v-row class="pl-5">
                    <v-col class="text-left pl-0" cols="6" sm="6" md="3"
                      >{{ appli.ticketName }}({{ appli.displayIndex }})</v-col
                    >
                    <v-col class="text-left" cols="6" sm="6" md="3">{{
                      appli.identityName
                        ? appli.identityName
                        : appli.lastName !== "" || appli.firstName !== ""
                        ? appli.lastName + appli.firstName
                        : ""
                    }}</v-col>
                    <v-col class="text-left" cols="6" sm="6" md="3">{{
                      appli.phoneNumber !== "" ? appli.phoneNumbe : ""
                    }}</v-col>
                    <v-col class="text-left" cols="6" sm="6" md="3">{{
                      appli.identityNumber !== "" ? appli.identityNumber : ""
                    }}</v-col>
                  </v-row>
                </v-col>
                <v-col
                  class="text-right d-flex align-center justify-end"
                  cols="2"
                  sm="2"
                  md="2"
                >
                  <div
                    role="button"
                    class="primary-1--text"
                    @click="showApplicantDialog(i)"
                  >
                    <div class="d-flex align-center">
                      <span class="d-none d-sm-block">{{
                        $t("userinfo_edit_cta")
                      }}</span>
                      <v-icon small color="primary-1 ml-1">mdi-pencil</v-icon>
                    </div>
                  </div>
                </v-col>
              </v-row>
              <v-row class="realname-note" align="center" justify="center">
                <v-col
                  class="text-left pl-0"
                  cols="10"
                  v-html="realnameNote"
                ></v-col>
              </v-row>
            </div>
          </div>
        </v-card>
        <CustomCard class="py-5">
          <template v-slot:title>
            <h4>{{ $t("order_step_2_user_info") }}</h4>
          </template>
          <v-col cols="12" sm="6" class="mx-auto mt-5">
            <v-form ref="form" lazy-validation>
              <v-text-field
                v-model="name"
                :label="$t('userinfo_name')"
                outlined
                disabled
                append-icon="mdi-lock"
              ></v-text-field>

              <v-text-field
                v-model="phone"
                :label="$t('phone_field')"
                outlined
                disabled
                append-icon="mdi-lock"
              ></v-text-field>

              <v-text-field
                v-model="email"
                :label="$t('footer_service_email')"
                outlined
                disabled
                append-icon="mdi-lock"
              ></v-text-field>
            </v-form>
          </v-col>
          <div class="text-body-2 font-weight-bold mb-5">
            {{ $t("order_step_2_user_info_notification") }}
          </div>
        </CustomCard>
      </template>
      <template v-if="!seatAssignment" v-slot:orderFooter>
        <v-col
          cols="12"
          sm="6"
          v-if="$vuetify.breakpoint.xs"
          class="d-flex justify-end align-center"
        >
          <v-checkbox
            v-model="guarantee"
            color="primary"
            class="mt-0 mb-4"
            dense
            hide-details
            @change="changeGuarantee"
          >
            <template slot="label">
              <div class="font-weight-bold text-nine">
                {{ $t("order_step_2_agree")
                }}<span
                  class="primary-1--text"
                  @click="e => gotoTerms('Terms')"
                >
                  &nbsp;{{ $t("register_terms") }}&nbsp;</span
                >{{ $t("register_and")
                }}<span
                  class="primary-1--text"
                  @click="e => gotoTerms('privacy')"
                >
                  &nbsp;{{ $t("register_privacy") }}</span
                >
              </div>
            </template>
          </v-checkbox>
        </v-col>
        <v-col cols="4" sm="3">
          <v-btn
            class="font-weight-bold"
            @click="preStep()"
            color="primary"
            block
            outlined
            depressed
            style="border: 2px solid"
            :large="$vuetify.breakpoint.xs"
            :x-large="!$vuetify.breakpoint.xs"
            >{{ $t(`order_cancel${campaign.isLottery ? "_lottery" : ""}`) }}
          </v-btn>
        </v-col>
        <v-spacer v-if="$vuetify.breakpoint.xs" />
        <v-col
          cols="4"
          sm="6"
          v-if="!$vuetify.breakpoint.xs"
          class="d-flex justify-end align-center px-4"
        >
          <v-checkbox
            v-model="guarantee"
            color="primary"
            class="mt-0"
            dense
            hide-details
            @change="changeGuarantee"
          >
            <template slot="label">
              <div class="font-weight-bold text-nine">
                {{ $t("order_step_2_agree")
                }}<span
                  class="primary-1--text"
                  @click="e => gotoTerms('Terms')"
                >
                  &nbsp;{{ $t("register_terms") }}&nbsp;</span
                >{{ $t("register_and")
                }}<span
                  class="primary-1--text"
                  @click="e => gotoTerms('privacy')"
                >
                  &nbsp;{{ $t("register_privacy") }}</span
                >
              </div>
            </template>
          </v-checkbox>
        </v-col>
        <v-col cols="4" sm="3" class="text-right">
          <v-btn
            class="nextBtn"
            :class="{ disabledBtn: !canNextStep }"
            :disabled="!canNextStep"
            @click="nextStep()"
            block
            depressed
            :large="$vuetify.breakpoint.xs"
            :x-large="!$vuetify.breakpoint.xs"
            >{{ $t("next_step") }}</v-btn
          >
        </v-col>
      </template>

      <template v-else v-slot:orderFooter>
        <v-col
          cols="12"
          v-if="$vuetify.breakpoint.xs"
          class="d-flex justify-end align-center"
        >
          <v-checkbox
            v-model="guarantee"
            color="primary"
            class="mt-0 mb-4"
            dense
            hide-details
            @change="changeGuarantee"
          >
            <template slot="label">
              <div class="font-weight-bold text-nine">
                {{ $t("order_step_2_agree")
                }}<span
                  class="primary-1--text"
                  @click="e => gotoTerms('Terms')"
                >
                  &nbsp;{{ $t("register_terms") }}&nbsp;</span
                >{{ $t("register_and")
                }}<span
                  class="primary-1--text"
                  @click="e => gotoTerms('privacy')"
                >
                  &nbsp;{{ $t("register_privacy") }}</span
                >
              </div>
            </template>
          </v-checkbox>
        </v-col>
        <v-col cols="6" sm="3">
          <v-btn
            class="font-weight-bold"
            @click="beforePreStep()"
            color="primary"
            block
            outlined
            depressed
            style="border: 2px solid"
            :x-large="!$vuetify.breakpoint.xs"
            >{{ $t("order_cancel") }}
          </v-btn>
        </v-col>
        <v-spacer v-if="$vuetify.breakpoint.xs" />
        <v-col
          cols="4"
          sm="6"
          v-if="!$vuetify.breakpoint.xs"
          class="d-flex justify-end align-center px-4"
        >
          <v-checkbox
            v-model="guarantee"
            color="primary"
            class="mt-0"
            dense
            hide-details
            @change="changeGuarantee"
          >
            <template slot="label">
              <div class="font-weight-bold text-nine">
                {{ $t("order_step_2_agree")
                }}<span
                  class="primary-1--text"
                  @click="e => gotoTerms('Terms')"
                >
                  &nbsp;{{ $t("register_terms") }}&nbsp;</span
                >{{ $t("register_and")
                }}<span
                  class="primary-1--text"
                  @click="e => gotoTerms('privacy')"
                >
                  &nbsp;{{ $t("register_privacy") }}</span
                >
              </div>
            </template>
          </v-checkbox>
        </v-col>
        <v-col cols="6" sm="3" class="text-right pl-2">
          <v-btn
            class="nextBtn"
            :class="{ disabledBtn: !canNextStep }"
            :disabled="!canNextStep"
            @click="nextStep()"
            block
            depressed
            :x-large="!$vuetify.breakpoint.xs"
            >{{ $t("next_step") }}</v-btn
          >
        </v-col>
      </template>
      {{ ccDiscounts || "" }}
      <CustomCard />
    </OrderTemplate>

    <ApplicantDialog
      v-if="sessionInfo && sessionInfo.realNameRegistration"
      :show="showApplicantForm"
      :tickets="products"
      :applicants="applicants"
      :applicant="currentApplicant"
      @close="closeApplicant"
      @beforeClose="beforeApplicantClose"
    />
  </div>
</template>

<script>
import OrderTemplate from "./OrderTemplate.vue";
import TicketTable from "./components/TicketsTable.vue";
import CulturePoint from "./components/CulturePoint.vue";
import ApplicantDialog from "./components/ApplicantDialog.vue";
import { mapGetters, mapActions } from "vuex";
import { CurrentReservedMixins } from "@/shared/mixins";
import jwt_decode from "jwt-decode";
import TM from "@/api/ticket-management";

export default {
  mixins: [CurrentReservedMixins, CulturePoint],
  components: {
    OrderTemplate,
    TicketTable,
    ApplicantDialog
  },
  data() {
    return {
      isReleased: false,
      couponDialogOpen: false,
      showApplicantForm: false,
      guarantee: false,
      isSubmit: false,
      name: "",
      email: "",
      phone: "",
      selectedDiscount: "0",
      couponCode: "",
      seats: [],
      applicants: [],
      currentApplicantIdx: -1,
      currentApplicant: null,
      reserveTickets: [],
      applicantLimit: 0,
      products: [],
      coupon: {
        get: false,
        name: "",
        discount: 0,
        error: ""
      },
      canNextStep: false,
      hasPostMessage: false
    };
  },
  metaInfo() {
    return {
      title: `${
        !this.areaAssignment
          ? this.$t("order_step_2")
          : this.$t("order_seat_step_3")
      } | ${this.sessionInfo.name || ""} | ${this.$t("app_name")}`,
      script: [
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: `${
              !this.areaAssignment
                ? this.$t("order_step_2")
                : this.$t("order_seat_step_3")
            } | ${this.sessionInfo.name || ""} | ${this.$t("app_name")}`,
            url: window.location.href
          }
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      timer: "order/timer",
      discounts: "order/discounts",
      updateResponse: "order/updateResponse",
      areaAssignment: "order/areaAssignment",
      seatAssignment: "order/seatAssignment",
      selectedArea: "order/selectedArea",
      tickets: "order/boughtTickets",
      reserveResponse: "order/reserveResponse",
      isPopState: "order/isPopState",
      pageData: "order/pageData",
      campaign: "event/campaign",
      sessionInfo: "session/sessionInfo",
      productData: "session/productData",
      ticketsData: "session/ticketsData"
    }),
    realnameNote() {
      return this.$t("realname_registration_note");
    },
    thead() {
      const defaultHead = [
        {
          name: "name",
          label: this.$t(
            `orderlist_product_name${this.campaign.isLottery ? "_lottery" : ""}`
          ),
          col: this.areaAssignment && !this.seatAssignment ? 3 : 5,
          class: this.$vuetify.breakpoint.xs ? "pl-4" : "px-8"
        },
        {
          name: "count",
          label: this.$t(
            `orderlist_product_count${
              this.campaign.isLottery ? "_lottery" : ""
            }`
          ),
          col: 2,
          class: this.$vuetify.breakpoint.xs ? "text-right pr-4" : "text-center"
        },
        {
          name: "price",
          label: this.$t("orderlist_product_price"),
          col: this.areaAssignment && !this.seatAssignment ? 2 : 3,
          class: this.$vuetify.breakpoint.xs ? "pl-4 mt-2" : "text-center"
        },
        {
          name: "sum",
          label: this.$t("orderlist_product_sum"),
          col: 2,
          class: this.$vuetify.breakpoint.xs
            ? "text-right pr-4 mt-2"
            : "text-center"
        }
      ];
      return this.areaAssignment && this.seatAssignment
        ? [
            {
              name: "ticketAreaName",
              label: this.$t(
                `orderlist_ticketarea_name${
                  this.campaign.isLottery ? "_lottery" : ""
                }`
              ),
              col: 3,
              class: this.$vuetify.breakpoint.xs ? "pl-4" : "px-8"
            },
            {
              name: "seat",
              label: this.$t("orderlist_ticketarea_seat"),
              col: 3,
              class: this.$vuetify.breakpoint.xs
                ? "text-right pr-4"
                : "text-center"
            },
            {
              name: "name",
              label: this.$t(
                `orderlist_product_name${
                  this.campaign.isLottery ? "_lottery" : ""
                }`
              ),
              col: 3,
              class: this.$vuetify.breakpoint.xs
                ? "pl-4 mt-2 mt-md-4"
                : "text-center"
            },
            {
              name: "price",
              label: this.$t("orderlist_product_price"),
              col: 3,
              class: this.$vuetify.breakpoint.xs
                ? "text-right pr-4 mt-2 mt-md-4"
                : "text-center"
            }
          ]
        : this.areaAssignment && !this.seatAssignment
        ? [
            {
              name: "ticketAreaName",
              label: this.$t(
                `orderlist_ticketarea_name${
                  this.campaign.isLottery ? "_lottery" : ""
                }`
              ),
              col: 12,
              colSm: 3,
              class: this.$vuetify.breakpoint.xs ? "pl-4" : "px-8"
            },
            ...defaultHead
          ]
        : defaultHead;
    },
    steps() {
      return !this.areaAssignment
        ? [
            this.$t("order_step_1"),
            this.$t("order_step_2"),
            this.$t("order_step_3")
          ]
        : [
            this.$t(
              `order_seat_step_1${this.campaign.isLottery ? "_lottery" : ""}`
            ),
            this.$t(
              `order_seat_step_2${this.campaign.isLottery ? "_lottery" : ""}`
            ),
            this.$t("order_seat_step_3"),
            this.$t(
              `order_seat_step_4${this.campaign.isLottery ? "_lottery" : ""}`
            )
          ];
    },
    couponRequired() {
      if (this.selectedDiscount == "1")
        return !!this.coupon || this.$t("order_step_2_coupon_code_required");
      else return true;
    },
    ccDiscounts() {
      const result = [];
      if (this.reserveData && this.reserveData.products.length) {
        for (let x = 0; x < this.reserveData.products.length; x++) {
          const {
            name: ticketName,
            ccDiscount,
            count: ticketCount,
            price: ticketPrice
          } = this.reserveData.products[x];

          if (ccDiscount && ccDiscount.length) {
            for (let y = 0; y < ccDiscount.length; y++) {
              const {
                discountCreditcardIdx,
                discountTitle,
                discountVal
              } = ccDiscount[y];
              const resultCcDiscount = result.find(
                ({ idx: resultIdx }) => resultIdx === discountCreditcardIdx
              );

              if (!resultCcDiscount) {
                result.push({
                  idx: discountCreditcardIdx,
                  discountTitle,
                  discount_total:
                    Math.round(ticketPrice * (1 - discountVal)) * ticketCount,
                  ticketNames: [ticketName]
                });
              } else {
                resultCcDiscount.discount_total =
                  Math.round(ticketPrice * (1 - discountVal)) * ticketCount;
                resultCcDiscount.ticketNames.push(ticketName);
              }
            }
          }
        }
      }

      this.$forceUpdate();
      return result;
    }
  },
  watch: {
    isPopState: {
      deep: true,
      handler: function(newVal, old) {
        if (newVal !== old && !newVal) {
          this.$store.dispatch("setOverlayLoading", true);
          this.init();
        }
      }
    },
    selectedDiscount(newVal, preVal) {
      let type = "";
      this.canNextStep = this.checkNextStep();
      this.$forceUpdate();
      if (Number(newVal) === 0) type = this.$t("order_step_2_no_discount");
      else if (Number(newVal) === 1)
        type = this.$t("order_step_2_coupon_code_field");
      else {
        const ccDiscount = this.ccDiscounts.find(
          (cc, i) => i + 2 === Number(newVal)
        );
        type = ccDiscount.discountTitle;
      }
      if (preVal == "1" && !this.discounts) {
        this.couponCode = "";
        this.coupon = {
          get: false,
          name: "",
          discount: 0,
          error: ""
        };
      }
    },
    couponCode() {
      if (this.coupon.get && !this.discounts) {
        this.coupon = {
          get: false,
          name: "",
          discount: 0,
          error: ""
        };
      }
    }
  },
  methods: {
    ...mapActions({
      setCountDownTimer: "order/countDownTimer",
      getLoginInfo: "user/getInfo",
      updateOrder: "order/updateOrder",
      setDiscount: "order/setDiscount",
      resetOrderState: "order/resetOrderState",
      showDialog: "dialog/show",
      use: "culturePoint/use",
      setPageData: "order/setPageData"
    }),
    changeDiscount() {
      this.canNextStep = this.checkNextStep();
      this.$forceUpdate();
    },
    checkNextStep() {
      if (this.guarantee) {
        if (this.selectedDiscount == "0" || this.selectedDiscount == 0)
          return true;
        else if (this.selectedDiscount == "1" || this.selectedDiscount == 1)
          return !this.coupon.error && this.coupon.discount;
        else if (this.selectedDiscount) return true;
      }
      return false;
    },
    changeGuarantee(e) {
      this.guarantee = e;
      this.canNextStep = this.checkNextStep();
      this.$forceUpdate();
    },
    setApplicant(ticket, i) {
      let app =
        ticket.applicants && ticket.applicants[i]
          ? { ...ticket.applicants[i], isComplete: true }
          : {
              firstName: "",
              lastName: "",
              identityName: "",
              identityNumber: "",
              nationality: "",
              birthday: "",
              age: "",
              gender: "",
              phoneNumber: "",
              address: "",
              email: "",
              emergencyContactPerson: "",
              emergencyContactRelation: "",
              emergencyContactPhoneNumber: "",
              shirtSize: "",
              worldgymId: "",
              isComplete: false
            };
      let appliIndex = this.applicants.length;
      this.applicants.push({
        ...app,
        ticket: ticket.idx,
        index: appliIndex,
        displayIndex: `${appliIndex + 1 < 10 ? "0" : ""}${appliIndex + 1}`,
        ticketName: ticket.name
      });
      this.$forceUpdate();
    },
    async init() {
      const { hasReservedOrder } = await this.checkReservedOrder();
      if (!this.reserveResponse.orderId) {
        if (hasReservedOrder) await this.setReservedData();
        else
          this.$router
            .push({
              name: "Order1",
              params: {
                eventId: this.$route.params.eventId,
                sessionId: this.$route.params.sessionId
              }
            })
            .catch(() => {});
      }
      this.canCulturePoint(this.campaign.culturePoint || false);

      const user = JSON.parse(Cookies.get("user"));
      const token = jwt_decode(user.access_token);

      const { maskedUserName, maskedMobile, maskedEmail } = token;

      this.name = maskedUserName;
      this.email = maskedEmail;
      this.phone = maskedMobile;

      if (
        !this.reserveResponse.tickets ||
        !this.reserveResponse.tickets.length
      ) {
        if (this.areaAssignment && this.seatAssignment)
          await this.setSeatArea();
        else await this.setTicket();
      } else if (
        this.reserveResponse &&
        this.reserveResponse.tickets &&
        this.reserveResponse.tickets.length
      ) {
        this.reserveTickets = this.reserveResponse.tickets.reduce(
          (accr, t, i) => {
            const p = this.reserveResponse.products.find(
              prod => t.productId === prod.id
            );
            const prod = this.productData.find(
              prod => t.productId === prod.productId
            );
            let value = {
              ...p,
              ...prod,
              ...t
            };
            if (t.culturePointProductInfos && !!t.culturePointProductInfos[0]) {
              value.culturePointProductInfos =
                t.culturePointProductInfos[
                  accr.filter(a => a.idx === t.idx).length
                ];
            }

            accr.push(value);
            return accr;
          },
          []
        );
      }

      this.reserveTicket({
        ...this.reserveResponse,
        products: this.reserveResponse.products.map(p => {
          const prod = this.productData.find(
            prod => p.productId === prod.productId
          );
          return {
            ...p,
            ...prod
          };
        }),
        tickets: this.reserveTickets
      });

      this.applicants = [];

      this.products = this.reserveTickets.reduce((accr, ticket, index) => {
        if (!this.areaAssignment) {
          for (let i = 0; i < ticket.count; i++) {
            if (this.sessionInfo.realNameRegistration) {
              this.setApplicant(ticket, i);
            }
            accr.push({
              ...ticket,
              count: 1,
              index: accr.length + 1
            });
          }
        } else {
          if (this.sessionInfo.realNameRegistration) {
            const area = this.ticketAreas;
            if (!this.seatAssignment) {
              for (let i = 0; i < ticket.count; i++) {
                this.setApplicant(ticket, i);
              }
            } else {
              this.setApplicant(ticket, index);
            }
          }
          accr.push({
            ...ticket,
            index: accr.length + 1
          });
        }
        return accr;
      }, []);

      this.reserveData = {
        ...this.reserveResponse,
        products: this.reserveResponse.products.map(prod => {
          const p = this.products.find(p => p.id === prod.productId);
          return {
            ...p,
            ...prod
          };
        })
      };
      if (this.sessionInfo.realNameRegistration) {
        this.applicantLimit = this.products.length;
      }

      if (this.discounts) {
        this.selectedDiscount = this.discounts.selected;

        if (this.discounts.selected === "1") {
          this.coupon = { ...this.discounts.discountDetail.coupon };
          this.couponCode = this.discounts.discountDetail.couponCode;
        }
      }

      if (!!this.pageData) {
        this._data = { ...this._data, ...Object.assign(this.pageData) };
        this.setPageData(null);
      }

      this.$gtm.trackView(
        `${!this.areaAssignment ? "填寫資料" : "確認資料"}-${
          this.sessionInfo.name
        }`,
        this.$route.path
      );

      this.$store.dispatch("setOverlayLoading", false);
    },
    applicantComplete(index) {
      let appli = !!this.reserveTickets
        ? this.reserveTickets[0].applicants[index]
        : this.applicants[index];
      let complete = true;
      for (var n in this.sessionInfo.applicants.properties) {
        let obj = this.sessionInfo.applicants.properties[n];
        if (obj.required && (!appli[n] || appli[n] === "")) complete = false;
      }
      return complete;
    },
    async setSeatArea() {
      const seats = this.reserveResponse.products.reduce(
        (accr, reserve, index) => {
          let seats = [];
          let product = prodData.products.find(p => p.productId === reserve.id);
          seats = reserve.seats.reduce((ary, seat) => {
            ary.push({
              ...reserve,
              ...product,
              ...seat,
              idx: reserve.idx,
              productId: reserve.productId
            });
            return ary;
          }, []);

          accr = accr.concat(seats);
          return accr;
        },
        []
      );

      this.reserveTickets = seats.map((seat, i) => {
        let ticket = this.tickets.find(t => t.productId === seat.productId);
        return { ...seat, ...ticket };
      });
    },
    async setTicket() {
      if (!this.reserveResponse.products) this.setTicket();
      else {
        this.reserveTickets = this.reserveResponse.products.reduce(
          (accr, reserve, index) => {
            let reserves = [];
            let selectedTicket = this.tickets.find(
              t => t.productId === reserve.productId
            );
            let prod = this.productData.find(
              p => p.productId === reserve.productId
            );
            this.applicantLimit += reserve.count;
            reserves.push({
              ...prod,
              ...reserve,
              ...selectedTicket
            });

            accr = accr.concat(reserves);
            return accr;
          },
          []
        );
      }
    },
    gotoTerms(terms) {
      if (terms === "privacy") {
        window.open(`/terms#privacy`);
        // this.$router.push({ name: "Terms" }).catch(() => {});
      } else {
        window.open(`/terms`);
        // this.$router.push({ name: "Terms", hash: "#privacy" }).catch(() => {});
      }
    },
    renderTicketName(value) {
      if (!value) return "";
      let ticket = this.products.find(t => t.index === value);
      return ticket.name + `${value < 10 ? `0${value}` : value}`;
    },
    closeApplicant(applicant) {
      debugger;
      if (!!this.currentApplicant) {
        this.applicants[this.currentApplicantIdx] = applicant;
        this.currentApplicant = null;
        this.currentApplicantIdx = -1;
      } else {
        this.applicants.push(applicant);
      }
      debugger;
      this.canNextStep = this.checkNextStep();
      this.showApplicantForm = false;
      this.$forceUpdate();
    },
    beforeApplicantClose(applicant) {
      const $this = this;
      debugger;
      this.showDialog({
        title: this.$t("orderlist_applicant_dialog_title"),
        content: this.$t("orderlist_applicant_dialog_content"),
        buttons: [
          {
            text: this.$t("layout_notification_cancel"),
            style: {
              block: true,
              outlined: true,
              color: "primary"
            },
            action() {
              setTimeout(() => {
                this.showApplicantForm = true;
                $this.$forceUpdate();
              }, 200);
            }
          },
          {
            text: this.$t("layout_notification_confirm"),
            style: {
              depressed: true,
              block: true,
              outlined: false,
              color: "primary"
            },
            action() {
              $this.showApplicantForm = false;
              $this.$forceUpdate();
            }
          }
        ]
      });
    },
    showApplicantDialog(i) {
      this.currentApplicantIdx = i;
      this.currentApplicant = this.applicants[i];
      this.showApplicantForm = true;
      this.$forceUpdate();
    },
    beforePreStep() {
      if (
        this.useCulturePoint &&
        !!this.reserveTickets[0].culturePointProductInfos
      )
        this.cancelCulturePoint(true, this.preStep);
      else this.preStep();
    },
    async preStep() {
      if (this.reserveResponse.orderId) {
        this.$store.dispatch("setOverlayLoading", true);
        const { data } = await TM.ticketRelease({
          orderId: this.reserveResponse.orderId
        });
        // await this.resetCulturePoint()
        this.isReleased = true;
        await this.resetOrderState();
        this.$store.dispatch("setOverlayLoading", false);
      }
      // 結帳_確認資料_{活動名稱}_{場次名稱}_取消購票
      this.setPageData(null);
      this.$router
        .push({
          name: "Order1",
          params: { sessionId: this.$route.params.sessionId }
        })
        .catch(() => {});
    },
    async nextStep() {
      this.isSubmit = true;
      if (
        this.sessionInfo.realNameRegistration &&
        this.applicants.find(a => !a.isComplete)
      ) {
        window.scrollTo({
          left: 0,
          top: document.querySelector("#applicant").offsetTop - 120,
          behavior: "smooth"
        });

        return false;
      }
      this.$store.dispatch("setOverlayLoading", true);
      let selectRadio = Number(this.selectedDiscount);
      // applicant
      let updateParams = {
        orderId: this.reserveResponse.orderId
      };
      // no discount
      if (this.selectedDiscount !== "0") {
        this.setDiscount({
          selected: this.selectedDiscount,
          discountDetail:
            this.selectedDiscount === "1"
              ? {
                  coupon: this.coupon,
                  couponCode: this.couponCode
                }
              : [this.ccDiscounts[Number(this.selectedDiscount - 2)]]
        });
      } else {
        this.setDiscount(null);
      }
      // none
      if (selectRadio == 0) {
        updateParams = {
          ...updateParams,
          orderId: this.reserveResponse.orderId,
          discountInfo: {
            type: "none"
          }
        };
      }
      // cc
      else if (selectRadio >= 2) {
        updateParams = {
          ...updateParams,
          orderId: this.reserveResponse.orderId,
          discountInfo: {
            type: "CC",
            content: {
              idx: this.ccDiscounts[selectRadio - 2].idx
            }
          }
        };
      }

      if (this.sessionInfo.realNameRegistration) {
        let applicantList = this.applicants.reduce((accr, app, i) => {
          let appli = {
            ...app,
            phoneNumber: app.phoneNumber || ""
          };
          let tick = app.ticket;
          delete appli.ticket;
          delete appli.index;
          delete appli.displayIndex;
          delete appli.isComplete;
          delete appli.tempemergencyContactPhoneNumber;
          delete appli.tempemergencyContactPhoneCountry;
          delete appli.tempphoneNumber;
          delete appli.tempphoneCountry;
          delete appli.ticketName;
          let data = {
            ...appli,
            idx: tick
          };
          if (!!app.worldgymId) {
            data.worldgymId = app.worldgymId;
          }
          accr.push(data);
          return accr;
        }, []);

        updateParams.applicantsInfo = {
          applicants: applicantList
        };
      }

      if (this.campaign.pickUp && this.campaign.pickUp[0] === "none") {
        updateParams.pickupInfo = { type: "none" };
      }

      const { data: updateResponse } = await TM.ticketUpdate(updateParams);

      if (updateResponse.errCode === "999") {
        window.isErrorToBack = true;
        this.showDialog({
          alert: true,
          title: this.$t("activity_busy_title"),
          content: this.$t("activity_busy_content")
        });
        setTimeout(() => {
          this.$store.dispatch("setOverlayLoading", false);
          window.location.href = `/order/${this.$route.params.eventId}/${this.$route.params.sessionId}`;
        }, 2000);
        return;
      }
      if (updateResponse.errCode == "00") {
        this.updateOrder({
          ...updateResponse,
          tickets: this.reserveResponse.tickets
        });
        this.$router.push({ name: "Order3" }).catch(() => {});
      } else if (updateResponse.errCode == "142") {
        this.$store.dispatch("setOverlayLoading", false);
        this.showDialog({
          alert: true,
          content: `<div class="pa-6 text-center font-weight-bold">
          <img
            src="/image/ic-warning@3x.png"
            alt=""
            style="width:80px"
          />
          <div class="mt-5">優惠折扣後訂單金額有誤，請取消優惠設定</div>
        </div>`
        });
      } else {
        this.$store.dispatch("setOverlayLoading", false);
        this.showDialog({
          alert: true,
          content: `<div class="pa-6 text-center font-weight-bold">
          <img
            src="/image/ic-warning@3x.png"
            alt=""
            style="width:80px"
          />
          <div class="mt-5">${this.$t("order_step_2_update_fail")}</div>
        </div>`
        });
      }
    },
    async checkCoupon() {
      const { data: chcekCoupon } = await TM.ticketUpdate({
        orderId: this.reserveResponse.orderId,
        discountInfo: {
          type: "coupon",
          content: {
            code: this.couponCode
          }
        }
      });
      // console.log(chcekCoupon);
      if (chcekCoupon.errCode === "999") {
        window.isErrorToBack = true;
        this.showDialog({
          alert: true,
          title: this.$t("activity_busy_title"),
          content: this.$t("activity_busy_content")
        });
        setTimeout(() => {
          this.$store.dispatch("setOverlayLoading", false);
          window.location.href = `/order/${this.$route.params.eventId}/${this.$route.params.sessionId}`;
        }, 3000);
        return;
      }
      if (chcekCoupon.errCode == "118")
        this.coupon.error = this.$t("order_step_2_coupon_failed");
      else if (chcekCoupon.errCode == "119")
        this.coupon.error = this.$t("order_step_2_coupon_empty");
      else if (chcekCoupon.errCode == "00") {
        this.coupon.get = true;
        this.coupon.name = chcekCoupon.discountName;
        this.coupon.discount = chcekCoupon.discountAmount;

        this.setPageData({
          ...this.pageData,
          ...this._data
        });
        this.updateOrder(chcekCoupon);
      } else {
        this.showDialog({
          alert: true,
          content: `<div class="pa-6 text-center font-weight-bold">
            <img
              src="/image/ic-warning@3x.png"
              alt=""
              style="width:80px"
            />
            <div class="mt-5">${this.$t("confirm_st_submit_fail")}</div>
          </div>`
        });
      }
    },
    inputField() {
      this.coupon.error = "";
    }
  },
  beforeRouteLeave(to, from, next) {
    if (
      !window.isErrorToBack &&
      !["Order3", "ConfirmSt"].includes(to.name) &&
      this.reserveResponse.orderId &&
      !this.isReleased &&
      this.timer > 0
    ) {
      console.log("beforeRouteLeave", "timer: " + this.timer);
      next(false);
      this.leaveConfirmation(to);
      return false;
    }
    window.isErrorToBack = null;
    next();
  },
  async beforeMount() {},
  async mounted() {
    if (window.orderCanceled) {
      this.$router
        .push({
          name: "Order1",
          params: {
            eventId: this.$route.params.eventId,
            sessionId: this.$route.params.sessionId
          }
        })
        .catch(error => {});
      window.isProccess = false;
      window.orderCanceled = false;
    }
    if (!this.isPopState) {
      this.$store.dispatch("setOverlayLoading", true);
      await this.init();
      this.use(
        this.reserveResponse.culturePointDeductAmount &&
          this.reserveResponse.culturePointDeductAmount > 0
          ? true
          : false
      );

      if (
        this.reserveResponse.discountInfo &&
        this.reserveResponse.discountInfo.type === "CC"
      ) {
        const index = this.ccDiscounts.findIndex(
          cc => cc.idx === this.reserveResponse.discountInfo.content.idx
        );
        this.selectedDiscount = String(2 + index);
      }
      if (!this.$store.state.order.counterInterval) this.setCountDownTimer();
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  label {
    font-weight: 500;
  }

  .applicant-info {
    .col {
      line-height: 36px;
    }

    @media screen and (max-width: 600px) {
      margin: 0 !important;

      .col {
        line-height: 24px;
      }
    }
  }

  .applicant-number {
    display: inline-block;
    width: 36px;
    height: 36px;
    line-height: 36px;
    font-weight: bold;
    text-align: center;
    border-radius: 50%;
    background: $primary-1;

    @media screen and (max-width: 600px) {
      width: 24px;
      height: 24px;
      line-height: 24px;
    }
  }

  .v-input__slot {
    margin-bottom: 0;
  }

  .theme--light.v-input--is-disabled input {
    color: #444444;
  }

  .discountGroup {
    color: #8d8d8d;

    label {
      color: #8d8d8d;
    }

    .v-item--active {
      label {
        color: #444444;
      }
    }
  }
}

// xs and sm
@media screen and (max-width: 960px) {
  .rwd-padding {
    padding: 0 16px;
  }
}

// greater than sm
@media only screen and (min-width: 960px) {
  .rwd-padding {
    padding: 0 32px;
  }
}

.order-footer .v-btn,
.order-footer .v-btn.v-btn--outlined:not(.v-btn--disabled) {
  padding-left: 12px;
  padding-right: 12px;
}
</style>
